module.exports = __webpack_public_path__ + "img/Yep-Logo-Hex.52240f9e.png";